import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    component: () => import("../layouts/AuthLayout.vue"),
    redirect: "/login",
    children: [
      {
        path: "/login",
        name: "login",
        component: () => import("../views/Auth/login.vue"),
      },
    ],
  },
  {
    path: "/contactus",
    name: "contactus",
    component: () => import("../views/Contactus/index.vue"),
  },
  {
    path: "/overview",
    name: "overview",
    component: () => import("../layouts/AdminLayout.vue"),
    children: [
      {
        path: "/overview",
        name: "overview",
        component: () => import("../views/Overview"),
      },
      {
        path: "/template",
        component: () => import("../views/Template"),
      },
      {
        path: "/templatetasks",
        component: () => import("../views/TemplateTasks"),
      },
      {
        path: "/maintenance",
        component: () => import("../views/Maintenance/index.vue"),
      },
      {
        path: "/subscriptions",
        alias: ["/plans"],
        component: () => import("../views/Subscriptions"),
      },
      {
        path: "/subscriptions2",
        component: () => import("../views/Subscriptions/premiumusers.vue"),
      },
      {
        path: "/organizations/:type?",
        component: () => import("../views/Users"),
      },
      {
        path: "/department",
        component: () => import("../views/Department"),
      },
      {
        path: "/request-log",
        component: () => import("../views/RequestLog/index.vue"),
      },
      {
        path: "/transaction",
        component: () => import("../views/Transaction/index.vue"),
      },
    ],
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});
router.beforeEach((to, from, next) => {
  const super_roomround_access_token = localStorage.getItem(
    "super_roomround_access_token"
  );
  if (super_roomround_access_token) {
    if (to.name === "login") {
      next({ name: "overview" });
    } else {
      next();
    }
  } else if (to.name === "login") {
    next();
  } else if (to.name === "contactus") {
    next();
  } else {
    next({ name: "login" });
  }
});
export default router;
